import { Layout } from '@/components/layout/Layout';
import { ContactSupportForm } from '@/components/support/ContactSupportForm';
import { Mail, Phone, MapPin, Clock, Headphones } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { SEOHead } from '@/components/SEOHead';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Ethio Real Estates',
  url: 'https://ethiorealestates.com/contact',
  email: 'support@ethiorealestates.com',
  telephone: '+251110000000',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Bole',
    addressLocality: 'Addis Ababa',
    addressCountry: 'ET',
  },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '08:30',
    closes: '18:00',
  }],
};

export default function ContactUs() {
  return (
    <Layout>
      <SEOHead
        title="Contact Ethio Real Estates Customer Support"
        description="Reach the Ethio Real Estates support team by email, phone or message. We're here Monday to Saturday for buyers, agents and developers."
        canonical="/contact"
        jsonLd={contactJsonLd}
      />
      <div className="bg-gradient-to-b from-primary/5 to-background">
        <div className="container py-10 md:py-14">
          <div className="max-w-3xl mx-auto text-center mb-8">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary mb-3">
              <Headphones className="h-7 w-7" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mb-2">Contact Customer Support</h1>
            <p className="text-muted-foreground">
              Got a question, complaint or feedback? Our support team is ready to help.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <div className="lg:col-span-1 space-y-3">
              <Card className="p-4 flex items-start gap-3">
                <Mail className="h-5 w-5 text-primary mt-0.5" />
                <div><p className="text-sm font-semibold">Email</p><p className="text-xs text-muted-foreground">support@ethiorealestates.com</p></div>
              </Card>
              <Card className="p-4 flex items-start gap-3">
                <Phone className="h-5 w-5 text-primary mt-0.5" />
                <div><p className="text-sm font-semibold">Phone</p><p className="text-xs text-muted-foreground">+251 11 000 0000</p></div>
              </Card>
              <Card className="p-4 flex items-start gap-3">
                <MapPin className="h-5 w-5 text-primary mt-0.5" />
                <div><p className="text-sm font-semibold">Office</p><p className="text-xs text-muted-foreground">Bole, Addis Ababa, Ethiopia</p></div>
              </Card>
              <Card className="p-4 flex items-start gap-3">
                <Clock className="h-5 w-5 text-primary mt-0.5" />
                <div><p className="text-sm font-semibold">Hours</p><p className="text-xs text-muted-foreground">Mon–Sat, 8:30 AM – 6:00 PM EAT</p></div>
              </Card>
            </div>
            <Card className="lg:col-span-2 p-6">
              <h2 className="font-semibold text-lg mb-1">Send us a message</h2>
              <p className="text-xs text-muted-foreground mb-4">
                We will create a tracked support ticket and reply to your email.
              </p>
              <ContactSupportForm />
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  );
}
